import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async getName(cpf: string) {
    return wrapEndpoint(() =>
      client.GET('/cpf/check/{cpf}', {
        params: {
          path: {
            cpf,
          },
        },
      }),
    )
  },
  async getData(cpf: string) {
    return wrapEndpoint(() =>
      client.GET('/cpf/data/{cpf}', {
        params: {
          path: {
            cpf,
          },
        },
      }),
    )
  },
}
